import { useSyncExternalStore } from "react";
import usePostMessageConfig from "./usePostMessageConfig";

const useConfigRenderer = () => {
	const { createSelector, subscribe } = usePostMessageConfig();

	return useSyncExternalStore(
		subscribe,
		createSelector("renderer"),
	);
};

export default useConfigRenderer;
